import React, { useContext, useEffect, useRef, useState } from 'react'
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList as List } from "react-window";
import Divider from '@material-ui/core/Divider'
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import Search from '@material-ui/icons/Search';
import { Button, Typography } from '@material-ui/core';
import { ZONES_LIST_MAX_HEIGHT } from '../../constants'
import { CreateCartoMapContext } from '../../../../../contexts/carto-maps-context'
import ZoneCard from '../ZoneCard'
import EmptyMessage from '../EmptyMessage'
import './style.css';

const FromProjectCard = () => {
    const { 
        fromDisplayedZones, 
        setFromDisplayedZones, 
        fromProject, 
        zonesSelected, 
        projects, 
        selectedFromProject, 
        setSelectedFromProject,
    } = useContext(CreateCartoMapContext)

    const [ searchterm, setSearchterm ] = useState('')
    
    const inputLabel = useRef('');
    const [ labelWidth, setLabelWidth ] = useState(0);

    // Sets the Label Width for Material UI Select Input
    useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
    }, []);

    // When project changes update the list of Zones displayed
    useEffect(() => {
        setFromDisplayedZones(fromProject.zones)
    }, [fromProject.zones])

    // Update list of Zones displayed when searchterm changes
    useEffect(() => {
        const filteredZones = fromProject.zones.filter(zone => zone.name.toUpperCase().includes(searchterm.toUpperCase()))
        setFromDisplayedZones(filteredZones)
    }, [searchterm])

  
    function handleOnClick(id) {
        // remove fromProjects
        const newZones = fromDisplayedZones.filter(zone => zone._id !== id)
        setFromDisplayedZones(newZones)

        // push zonesSelected
        const zoneToCopy = fromProject.zones.find(zone => zone._id === id)

        zonesSelected.setZones([ ...zonesSelected.zones, zoneToCopy ])
    }

    function addAllZones() {
        setFromDisplayedZones([])
        zonesSelected.setZones(fromProject.zones)
    }

    function renderZoneRows () {
        if (!selectedFromProject) {
            return <EmptyMessage>You need to choose which Project</EmptyMessage>
        }

        if (selectedFromProject && fromProject.zones.length === 0) {
            return <EmptyMessage>This Project has no Zones</EmptyMessage>
        }

        return (  
            <AutoSizer> 
                {({ height, width }) => (
                    <List
                        height={height < ZONES_LIST_MAX_HEIGHT ? height : ZONES_LIST_MAX_HEIGHT}
                        itemCount={ fromDisplayedZones.length }
                        itemData={{ zones: fromDisplayedZones, onClick: handleOnClick }}
                        itemSize={60}
                        width={width}
                    >
                       { ZoneCard }
                    </List>
                )}
            </AutoSizer>
        )
    }

    return (
        <div className="from-project-card-container">
            <div className="flex-container card-header">
                <h4>From Project</h4>
                <FormControl variant="outlined" className="select-project-wrapper">
                    <InputLabel ref={inputLabel} id="demo-simple-select-outlined-label" >
                        { projects && projects.length ? 'Project' : 'This account has no Projects'}
                    </InputLabel>
                        <Select
                            value={selectedFromProject}
                            onChange={(e) => setSelectedFromProject(e.target.value)}
                            labelWidth={labelWidth}
                            width={20}
                            disabled={!(projects && projects.length)}
                        >
                            { projects.map(project => <MenuItem key={project._id} value={project}>{project.name}</MenuItem>) }
                        </Select>
                </FormControl> 
            </div>
            <Divider component="div"/>
            <div className="flex-container searchbox-wrapper">
                <h5 className="zones-section-label">Zones</h5>
                <div className="search-input-wrapper">
                    <Input
                        id="input-with-icon-adornment"
                        fullWidth
                        placeholder="Search Zones by name"
                        onChange={e => setSearchterm(e.target.value)}
                        startAdornment={
                            <InputAdornment position="start">
                                <Search color="primary"/>
                            </InputAdornment>
                        }
                    />
                </div>
                <Button 
                    color="primary" 
                    onClick={addAllZones}
                >
                    <Typography variant="button">ADD ALL</Typography>
                </Button>
            </div>
            { renderZoneRows() }
        </div>
    )
}

export default FromProjectCard